import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "group-chip__label" };
const _hoisted_2 = ["aria-label"];
import { computed } from "vue";
import { TAG_COLORS } from "@/constants/tagColors";
export default /*@__PURE__*/ _defineComponent({
    __name: 'GroupChip',
    props: {
        group: {},
        size: { default: "sm" },
        removable: { type: Boolean, default: false }
    },
    emits: ["remove"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const palette = TAG_COLORS;
        const hex = computed(() => palette[props.group.color] || palette.grey);
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["group-chip", `group-chip--${__props.size}`]),
                style: _normalizeStyle({ '--group-color': hex.value })
            }, [
                _createVNode(_component_v_icon, {
                    size: __props.size === 'md' ? 13 : 11,
                    class: "group-chip__icon"
                }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("mdi-account-group", -1)
                        ]))]),
                    _: 1
                }, 8, ["size"]),
                _createElementVNode("span", _hoisted_1, _toDisplayString(__props.group.name), 1),
                (__props.removable)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "group-chip__remove",
                        "aria-label": `Unassign ${__props.group.name}`,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('remove', __props.group.id)), ["stop"]))
                    }, [
                        _createVNode(_component_v_icon, {
                            size: __props.size === 'md' ? 13 : 11
                        }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                    _createTextVNode("mdi-close", -1)
                                ]))]),
                            _: 1
                        }, 8, ["size"])
                    ], 8, _hoisted_2))
                    : _createCommentVNode("", true)
            ], 6));
        };
    }
});
